import { useCallback, useMemo, useState } from 'react';
import * as columnDefs from '../../../../../components/AGGrid/config/columns-def';
import {filterCriteria} from "../../../../../utils/filterCriteria";

export function useSharedSectionsGridUtils({
                                         datastageApi,
                                         filterForm,
                                               defaultFilterRange,
                                         updateSharedSections,
                                         handlers
                                     }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {
                const data = await datastageApi.sharedSections(
                    filterCriteria(filterForm, '', 'sharedSections'),
                    defaultFilterRange,
                    [colId, direction.toUpperCase()]
                );
                updateSharedSections({
                    shared: data?.content,
                    totalPages: data?.totalPages,
                    totalItems: data?.totalElements,
                    currentPage: data?.pageable?.pageNumber,
                    sectionSort: [colId, direction.toUpperCase()]
                });
            } catch (error) {
                console.error('Error sorting shared sections:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [filterForm, defaultFilterRange, updateSharedSections, handlers]
    );

    const baseColumns = columnDefs['sharedSections'](
        ...handlers.columnHandlers
    )['default'];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return { setSort, columns };
}